/* unplugin-vue-components disabled */import { render } from "./NotFound.vue?vue&type=template&id=8f4703ae"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__